import { useIntercomMessengerPayloadQuery } from "@/lib/queries/user-queries";
import { getEnv } from "@/lib/utils";
import { Intercom, boot, shutdown, update } from "@intercom/messenger-js-sdk";
import { useEffect, useRef } from "react";

export default function IntercomMessenger() {
  const isIntercomInitialized = useRef(false);
  const { data } = useIntercomMessengerPayloadQuery();

  const signedPayload = data?.signedPayload;

  useEffect(() => {
    const appId = getEnv("VITE_INTERCOM_APP_ID");

    if (!appId) {
      console.info("Intercom app ID is not set");
      return;
    }

    if (isIntercomInitialized.current) {
      if (!signedPayload) {
        shutdown();
        boot({
          app_id: appId,
        });
        return;
      }

      update({
        intercom_user_jwt: signedPayload,
      });
      return;
    }

    Intercom({
      app_id: appId,
      intercom_user_jwt: signedPayload,
    });

    isIntercomInitialized.current = true;
  }, [signedPayload]);

  return null;
}
